import type { NodeTransformer } from './types';

export const toSupportedPanel: NodeTransformer = (partialNodeJson) => {
	if (partialNodeJson.attrs?.panelType === 'tip') {
		return {
			...partialNodeJson,
			attrs: { ...partialNodeJson.attrs, panelType: 'info' },
		};
	}

	return partialNodeJson;
};
